import { useState, useEffect } from 'react';

export type OperatingSystem = 'win' | 'mac' | 'linux';

export const useOsDetection = (defaultOs: OperatingSystem = 'win'): OperatingSystem => {
  const [os, setOs] = useState<OperatingSystem>(defaultOs);

  useEffect(() => {
    const detectOs = (): OperatingSystem => {
      if (typeof window === 'undefined' || !navigator) {
        return defaultOs;
      }

      const userAgent = navigator.userAgent.toLowerCase();

      if (userAgent.indexOf('win') !== -1) return 'win';
      if (userAgent.indexOf('mac') !== -1) return 'mac';
      if (userAgent.indexOf('linux') !== -1) return 'linux';

      return defaultOs;
    };

    setOs(detectOs());
  }, [defaultOs]);

  return os;
};
